import { gql } from "@apollo/client";

export const removeBooksQuery = gql`
mutation removeBooksQuery($bookIds: [String!]!) {
  removeBooks(bookIds: $bookIds) {
    success
  }
}
`;
